import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  constructor(){
  }
  public deleteCacheUser() {
    localStorage.removeItem("token");
  }

  public cache(key, value) {
    localStorage.setItem(key, value);
  }
  public getCache(key) {
    return localStorage.getItem(key);
  }
  
  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    return item.value;
  }
}
